/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CheckInviteMutationRequest,
  CheckInviteMutationResponse,
  CheckInvite422,
} from '../types/CheckInvite'

function getCheckInviteUrl() {
  const res = { method: 'POST', url: `/api/v1/auth/check-invite/` as const }
  return res
}

/**
 * @description Check if an invitation token is valid.
 * @summary Validate an invitation token
 * {@link /api/v1/auth/check-invite/}
 */
export async function checkInvite(
  data: CheckInviteMutationRequest,
  config: Partial<RequestConfig<CheckInviteMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CheckInviteMutationResponse,
    ResponseErrorConfig<CheckInvite422>,
    CheckInviteMutationRequest
  >({
    method: 'POST',
    url: getCheckInviteUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
